import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { CompetitivePriceFileEntity } from './competitive-price-file.entity';
import { ItemEntity } from './item.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_item__id', ['fkItemId'], {})
@Index('competitive_price_fk_wholesaler__id', ['fkWholesalerId'], {})
@Entity('competitive_price')
export class CompetitivePriceEntity extends BaseEntity {
	@Column('decimal', { name: 'price', nullable: true, precision: 15, scale: 6 })
	public price!: string | null;

	/**
	 * The competitor as typed. Kept, and filled with the competitor's name when
	 * one is picked, because SM1, the storefront and the price-change
	 * notification read this text (PD-17066).
	 */
	@Column('varchar', { name: 'vendorName', length: 255 })
	public vendorName!: string;

	/** The competitor this price is from, when known (PD-17066). */
	@Column('int', { name: 'fk_wholesaler__id', nullable: true, unsigned: true })
	public fkWholesalerId!: number | null;

	/**
	 * Free text about the price ("same price as always"). The competitive price
	 * backfill moves text that was typed into `vendorName` but is not a
	 * competitor here, leaving `vendorName` as it was.
	 */
	@Column('text', { name: 'note', nullable: true })
	public note!: string | null;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@ManyToOne(() => ItemEntity, (item) => item.competitivePrices, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;

	@ManyToOne(() => ClientEntity, (client) => client.competitivePrices, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@OneToMany(
		() => CompetitivePriceFileEntity,
		(competitivePriceFile) => competitivePriceFile.fkCompetitivePrice,
		{},
	)
	public competitivePriceFiles!: Array<CompetitivePriceFileEntity>;
}
